import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { logError } from 'services/logging/logging';
import { useSupplierPublicInfo } from 'services/repositories/orderForms/orderForms';

import { LoadingPage } from 'components/Loading/LoadingPage';
import { NotFoundPage } from 'components/Page/NotFoundPage';

import { LoginStateProvider } from '../contexts/LoginStateContext/LoginStateProvider';
import { useRedirectAuthorizedToOrderForm } from '../hooks/useRedirectAuthorizedToOrderForm';

import { OrderFormAuthLayout } from '../components/OrderFormAuthLayout/OrderFormAuthLayout';
import { OrderFormDialog } from '../components/OrderFormDialog/OrderFormDialog';
import { LoginForm } from './LoginForm/LoginForm';
import { LoginHeading } from './LoginHeading/LoginHeading';

export function OrderFormLogin() {
  const params = useParams<{ supplierSlug: string }>();
  const { isLoading: isCheckingForAuthorization } = useRedirectAuthorizedToOrderForm();
  const {
    data,
    isLoading: isLoadingPublicInfo,
    isError,
    error,
  } = useSupplierPublicInfo({
    variables: { supplierSlug: params.supplierSlug },
  });

  useEffect(() => {
    if (error) {
      logError(error);
    }
  }, [error]);

  if (isError) {
    return <NotFoundPage />;
  }

  if (isLoadingPublicInfo || isCheckingForAuthorization) {
    return (
      <OrderFormAuthLayout className="justify-center">
        <LoadingPage />
      </OrderFormAuthLayout>
    );
  }

  return (
    <OrderFormAuthLayout>
      <LoginStateProvider>
        <OrderFormDialog heading={<LoginHeading supplierName={data?.data?.name || ''} />}>
          <LoginForm />
        </OrderFormDialog>
      </LoginStateProvider>
    </OrderFormAuthLayout>
  );
}
